import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useGetUserContentDetailMutation } from "../../../../store/user/contentsApiSlice";
import { getCookie } from "../../../../util/cookie/cookies";

export const PromotionNewsView = () => {
    const {t} = useTranslation()
    const {thridUrl} = useParams()
    const navigate = useNavigate()
    const lang = getCookie('HYUNDAILANG')
    const [data, setData] = useState<any>([])
    const [getUserContentDetailApi] = useGetUserContentDetailMutation()
    const getDetail = async() => {
        const result : any = await getUserContentDetailApi({contentsType : 1, idx : thridUrl})
        if(result.data.result === true){
            setData(result.data.list)
        }
    }
    useEffect(()=>{
        getDetail()
    }, [])
    return(
        <>
        <div className="contentBox">
            <span>{data?.prom_tech_type}</span>
            <h3>
                {lang === 'kr' ? data?.prom_subject_kr : data?.prom_subject_en}
            </h3>
            <div className="txtBox">
                <div dangerouslySetInnerHTML={{__html : lang === 'kr' ? data?.prom_contents_kr : data?.prom_contents_en}}></div>
            </div>
            <div className="btnBox">
                <button onClick={()=>navigate(-1)}>{t("prcenter_news_5")}</button>
            </div>
        </div>
        </>
    )
}